import { TTypeOfCodec } from "../../shared/src/codecs/codec";
import { boolean } from "../../shared/src/codecs/types/boolean";
import { intersection } from "../../shared/src/codecs/types/intersection";
import { nullCodec } from "../../shared/src/codecs/types/nullCodec";
import { positiveInteger } from "../../shared/src/codecs/types/positiveInteger";
import { postcode } from "../../shared/src/codecs/types/postcode";
import { required } from "../../shared/src/codecs/types/required";
import { string } from "../../shared/src/codecs/types/string";
import { date } from "../../shared/src/codecs/types/date";
import { union } from "../../shared/src/codecs/types/union";
import { uuid } from "../../shared/src/codecs/types/uuid";
import { Address4 } from "./Address";
import { CallbackPreference1 } from "./CallbackPreference";
import { TransactionType1 } from "./TransactionType";
import { CreateUser } from "./User";

export const PublicPropertyReportAddressSearch = required({
    introducer_id: union([nullCodec(), uuid()]),
    deceased_name: string(),
    date_of_death: union([nullCodec(), date()]),
    building_number_name: string(),
    postcode: postcode(),
    transaction_type: union([nullCodec(), TransactionType1]),
    wants_valuation: union([nullCodec(), boolean()]),
    introducer: CreateUser,
    introducer_external_reference_id: string(),
    introducer_notes: string(),
    // The introducer asked us not to approach the family before this date. Holds
    // the VAL notification only - the title check, quotes and listing all still
    // happen immediately. NULL means contact as usual.
    do_not_contact_until: union([nullCodec(), date()]),
    executor_or_beneficiary: intersection([
        CreateUser,
        required({
            is_executor: boolean(),
        }),
    ]),
});
export type TPublicPropertyReportAddressSearchCodec = typeof PublicPropertyReportAddressSearch;

export const PublicPropertyReportTitleSearch = intersection([
    required({
        id: positiveInteger(),
        introducer_id: union([nullCodec(), uuid()]),
        deceased_name: string(),
        date_of_death: union([nullCodec(), date()]),
        transaction_type: union([nullCodec(), TransactionType1]),
        wants_valuation: union([nullCodec(), boolean()]),
        introducer: CreateUser,
        introducer_external_reference_id: string(),
        introducer_notes: string(),
        // Carried through the title-search step so the embargo survives to listing
        // creation, which is the only place it has any effect.
        do_not_contact_until: union([nullCodec(), date()]),
        executor_or_beneficiary: intersection([
            CreateUser,
            required({
                is_executor: boolean(),
            }),
        ]),
    }),
    Address4,
]);
export type TPublicPropertyReportTitleSearchCodec = typeof PublicPropertyReportTitleSearch;
export type TPublicPropertyReportTitleSearch = TTypeOfCodec<TPublicPropertyReportTitleSearchCodec>;

export const PublicPropertyReportCreate = intersection([
    required({
        title_number: string(),
        callback_preference: union([nullCodec(), CallbackPreference1]),
        admin_notes: string(),
    }),
    PublicPropertyReportTitleSearch,
]);
export type TPublicPropertyReportCreateCodec = typeof PublicPropertyReportCreate;
export type TPublicPropertyReportCreate = TTypeOfCodec<TPublicPropertyReportCreateCodec>;
